var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.00195312,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#6A84C5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.998,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#6A84C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.12323C4.44772 3.12323 4 3.57095 4 4.12323V11.9084C4 12.4607 4.44772 12.9084 5 12.9084H12C12.5523 12.9084 13 12.4607 13 11.9084V4.12323C13 3.57095 12.5523 3.12323 12 3.12323H5ZM7.88916 9.51674H8.80542C8.80542 9.28466 8.83662 9.06826 8.89901 8.86754C8.96141 8.66683 9.08292 8.4865 9.26355 8.32655C9.47373 8.13838 9.67241 7.9408 9.85961 7.73381C10.0468 7.52682 10.1995 7.30572 10.3177 7.0705C10.4392 6.83215 10.5 6.57185 10.5 6.28959C10.5 5.92265 10.4228 5.6059 10.2685 5.33932C10.1141 5.06961 9.88916 4.86262 9.5936 4.71835C9.30131 4.57409 8.94663 4.50195 8.52956 4.50195C8.15189 4.50195 7.81034 4.56938 7.50493 4.70424C7.19951 4.83909 6.95649 5.03354 6.77586 5.28757C6.59852 5.5416 6.50657 5.84582 6.5 6.20021H7.41133C7.41461 5.98067 7.4688 5.80348 7.57389 5.66862C7.67898 5.53063 7.81691 5.4287 7.98768 5.36284C8.15846 5.29698 8.33908 5.26405 8.52956 5.26405C8.75944 5.26405 8.95156 5.30639 9.10591 5.39107C9.26355 5.47574 9.38177 5.59649 9.46059 5.7533C9.54269 5.91011 9.58374 6.09671 9.58374 6.31311C9.58374 6.52637 9.54433 6.70984 9.46552 6.86351C9.3867 7.01405 9.28325 7.15518 9.15517 7.2869C9.03038 7.41548 8.89245 7.55348 8.74138 7.70088C8.53448 7.90473 8.36864 8.08663 8.24384 8.24658C8.11905 8.40652 8.02874 8.58372 7.97291 8.77816C7.92036 8.96947 7.89245 9.21566 7.88916 9.51674ZM7.98768 10.6505C7.89573 10.7477 7.84975 10.8669 7.84975 11.008C7.84975 11.1429 7.89573 11.2589 7.98768 11.3561C8.07964 11.4533 8.21264 11.502 8.3867 11.502C8.56404 11.502 8.69869 11.4533 8.79064 11.3561C8.88259 11.2589 8.92857 11.1429 8.92857 11.008C8.92857 10.8669 8.88259 10.7477 8.79064 10.6505C8.69869 10.5533 8.56404 10.5046 8.3867 10.5046C8.21264 10.5046 8.07964 10.5533 7.98768 10.6505Z",
    fill: "#6A84C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestsIcon);
export default __webpack_public_path__ + "static/media/quests-icon.6533f393de1ec2961fc4d66fc93ce7f5.svg";
export { ForwardRef as ReactComponent };